import { defineMessages } from 'react-intl';

// design: workspaces f1 / f2. Settings > Subscription of a member of the active workspace.
export const subscriptionMemberMessages = defineMessages({
  onPlan: { id: 'app.sml.settings.subscription.member.onPlan', defaultMessage: '{workspace} is on the {plan} plan' },
  onFree: { id: 'app.sml.settings.subscription.member.onFree', defaultMessage: '{workspace} is on Free' },
  intro: {
    id: 'app.sml.settings.subscription.member.intro',
    defaultMessage: 'You work here as a member. The owner chooses the plan and pays for it.',
  },
  endedOn: {
    id: 'app.sml.settings.subscription.member.endedOn',
    defaultMessage: 'The paid subscription ended on {date}.',
  },
  ended: { id: 'app.sml.settings.subscription.member.ended', defaultMessage: 'The paid subscription ended.' },
  managedBy: { id: 'app.sml.settings.subscription.member.managedBy', defaultMessage: 'Managed by {email}' },
  planRenews: { id: 'app.sml.settings.subscription.member.planRenews', defaultMessage: '{plan} · renews {date}' },
  freeArtists: {
    id: 'app.sml.settings.subscription.member.freeArtists',
    defaultMessage: '{plan} · {count, plural, one {# artist} other {# artists}} (Free includes {limit})',
  },
  ownerOf: {
    id: 'app.sml.settings.subscription.member.ownerOf',
    defaultMessage: 'Owner of {workspace}. Ask them about the plan, invoices or more seats.',
  },
  askRenew: {
    id: 'app.sml.settings.subscription.member.askRenew',
    defaultMessage: 'Ask the workspace owner to renew.',
  },
  managesBilling: {
    id: 'app.sml.settings.subscription.member.managesBilling',
    defaultMessage: '{email} manages billing for {workspace}. Your own workspace is not affected.',
  },
  seePlan: { id: 'app.sml.settings.subscription.memberSeePlan', defaultMessage: 'See what the plan includes' },
  artists: { id: 'app.sml.settings.subscription.member.limit.artists', defaultMessage: 'Artists' },
  seats: { id: 'app.sml.settings.subscription.member.limit.seats', defaultMessage: 'Seats' },
  history: { id: 'app.sml.settings.subscription.member.limit.history', defaultMessage: 'History' },
  social: { id: 'app.sml.settings.subscription.member.limit.social', defaultMessage: 'Social accounts' },
  ofLimit: { id: 'app.sml.settings.subscription.member.limit.of', defaultMessage: '/ {limit}' },
  days: { id: 'app.sml.settings.subscription.member.limit.days', defaultMessage: 'days' },
  max: { id: 'app.sml.settings.subscription.member.limit.max', defaultMessage: 'max' },
  unlimited: { id: 'app.sml.settings.subscription.member.limit.unlimited', defaultMessage: 'Unlimited' },
});
